import React from 'react'
import styled from "@emotion/styled";
import banner from "../../assets/images/sheep-attack.jpg"
const HomeBanner = () => {
    return (
        <Container>
            <Image
                src={banner}
                alt={"Image de présentation"}
            />
        </Container>
    )
}

export default HomeBanner

const Container = styled.div`
  height: calc(100vh - 60px);
  width: 100%;
  overflow: hidden;
  flex-direction: row;
  justify-content: center;
`

const Image = styled.img`
   height: 110%;
`
